import callApi from '../../util/apiCaller';
import { addError } from '../Error/ErrorActions';

// Export Constants
export const SET_VIDEO_TOKEN = 'SET_VIDEO_TOKEN';
export const ADD_USER_TRACK = 'ADD_USER_TRACK';
export const REMOVE_USER_TRACK = 'REMOVE_USER_TRACK';

// Export Actions
export function getVideoTokenRequest() {
    return dispatch => {
        return callApi('video/token', 'get').then(res => {
            if(res.token) {
                dispatch(setVideoToken(res.token));
            }
            return res.token;
        }).catch(error => {
            // displayErrors('error', "Impossible de vous connecter au serveur vidéo ! Veuillez réessayer...");
            dispatch(addError(error));
            return null;
        });
    };
}

// Getters
export function getVideoToken(store) {
    return store.video.token;
}

export function getRoomName(session, user, applicant = null) {
    // For normal proctoring, roomName is the id of the proctor(user) because only one proctor for 1-9 applicants (Twilio and screen limitations)
    // For thesis proctoring, roomName is the id of applicant, because only one applicant for 1-5 proctors(user)
    return `${session._id}-${applicant ? applicant._id : user._id}`;
}

// export function getUserTracks(store, userId) {
//     return (store.video.usersTracks.find(userTracks => userTracks.user === userId) || { tracks: [] }).tracks;
// }

// Actions
export function setVideoToken(token) {
    return {
        type: SET_VIDEO_TOKEN,
        token,
    };
}

// NOT WORKING BECAUSE TRACK FUNCTIONS ARE NOT SET IN REDUX STATE (like attach() or detach())
// export function addUserTrack(track, userId) {
//     return {
//         type: ADD_USER_TRACK,
//         track,
//         userId,
//     };
// }
//
// export function removeUserTrack(track, userId) {
//     return {
//         type: REMOVE_USER_TRACK,
//         track,
//         userId,
//     };
// }
